'use strict';

module.exports = {
    /* resolve browser's name */
    name: function () {
        var matches = require('./lib/browser-names').filter(function (browser) {
            return browser.pattern.test(navigator.userAgent);
        });
        if (matches.length) {
            return matches[0].name;
        } else {
            return 'N/A';
        }
    }(),

    /* resolve browser's vendor */
    vendor: function () {
        var matches = require('./lib/vendors').filter(function (vendor) {
            return vendor.pattern.test(navigator.vendor);
        });
        if (matches.length) {
            return matches[0].name;
        } else {
            return 'N/A';
        }
    }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@browser-detection/dist/index.js
// module id = 703
// module chunks = 0